// Angular modules
import { NgModule, ModuleWithProviders } from '@angular/core';
import { BsDropdownModule, ButtonsModule, CollapseModule, ModalModule, PopoverModule, TooltipModule, TypeaheadModule, AlertModule } from 'ngx-bootstrap';
import { DataTableModule } from 'angular2-datatable';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';



// Modules
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';

// https://github.com/leovo2708/ngx-treeview
import { TreeviewModule } from 'ngx-treeview';

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

//Directives
import * as directives from './directives';

//Pipes
import * as pipes from './pipes';

// Audit
import * as audit from './audit';

//files

import * as files from './file';

import * as editablePopover from './editable-popover';

//Components
import { AreaPlannerComponent } from './area-planner';

import * as contract from './contract';
import * as contractIfrs from './contract/ifrs';

import { PrettyJsonModule } from 'angular2-prettyjson';


import * as map from "./map";

import {

	AddEditAddressDialogComponent,
	AddressTypeTemplateDropdownComponent,
	CityDropDownComponent,
	CorporateBrandDropDownComponent,
	CountryDropDownComponent,
	DeleteDialogComponent,
	DropDownComponent,
	EditableButton,
	EditableDateComponent,
	ExtendedDropDownComponent,
	GeographicRegionDropDownComponent,
	ImageLoaderComponent,
	ImageModalComponent,
	IndustryTemplateDropdownComponent,
	OwnRegionDropDownComponent,
	PdfModalComponent,
	PopoverCountryCodeNameDropDownComponent,
	PopoverEditableIdNameDropdownComponent,
	PopoverEditableIdNameGenericDropdownComponent,
	PopoverEditableGenericDropDownComponent,
	PopoverEditableYesNoDropdown,
	SmallSpinnerComponent,

	StoreFormatDropDownComponent,
	TabStripComponent,
	PortletComponent,
	NumberDisplayComponent
} from './components';

import { DemarcationListTemplateComponent } from './components/demarcation';
import { LoadingContainerComponent } from './components/spinner';



import { SubShellComponent } from './sub-shell.component';
import { HierarcicalMenuComponent } from './hierarcical-menu.component';



// Styles
import './area-planner/area-planner.styles.less';

@NgModule({
	imports: [
		// Modules
		TreeviewModule.forRoot(),
		BsDropdownModule.forRoot(),
		ButtonsModule.forRoot(),
		CollapseModule.forRoot(),
		CommonModule,
		DataTableModule,
		FileUploadModule,
		FormsModule,
		ModalModule.forRoot(),
		NgxMyDatePickerModule.forRoot(),
		PopoverModule.forRoot(),
		ReactiveFormsModule,
		RouterModule.forChild([]),
		TooltipModule.forRoot(),
		AlertModule.forRoot(),
		TypeaheadModule.forRoot(),
		PrettyJsonModule,
		AngularMultiSelectModule,
		//ngx-datatable
	],

	declarations: [
		directives.AutoFocusDirective,

		// Components
		editablePopover.PopoverComponent,
		editablePopover.PopoverDropdownComponent,
		editablePopover.PopoverTextComponent,
		editablePopover.PopoverTextAreaComponent,
		editablePopover.PopoverNumberComponent,
		editablePopover.PopoverDateComponent,
		editablePopover.PopoverMonthComponent,
		editablePopover.PopoverCheckboxListComponent,
		editablePopover.PopoverRadioButtonListComponent,
		editablePopover.ClassificationCodeDropdownComponent,
		editablePopover.EditablePopoverCityDropdownComponent,
		editablePopover.OwnRegionDropdownComponent,
		editablePopover.PopoverSupplierDropdownComponent,
		editablePopover.PopoverSupplierSelectorComponent,
		editablePopover.PopoverContactDropdownComponent,
		editablePopover.PopoverMultipleStoreSelectTypeaheadComponent,
		editablePopover.MultipleOwnRegionStoreTreeComponent,
		editablePopover.PopoverTimeComponent,

		contract.ContractAssignmentSublettingComponent,
		contract.ContractBreakClauseComponent,
		contract.ContractDetailComponent,
		contract.ContractDemarcationListComponent,
		contract.ContractEscalationClauseComponent,
		contract.ContractExtensionComponent,
		contract.ContractGeneralContractInfoComponent,
		contract.ContractGeneralInfoComponent,
		contract.ContractRentChargesComponent,
		contract.ContractTermPossessionComponent,
		contract.ContractDocumentComponent,
		contract.ContractSimplifiedComponent,
		contract.ContractRentDeductionComponent,

		contractIfrs.EntryComponent,
		contractIfrs.CalculationRentCostsRentalSupplementsComponent,
		contractIfrs.CostsWithOwnIndex,
		contractIfrs.ResultsFromInputs,
		contractIfrs.IndexCalculationInformationComponent,
		contractIfrs.TaxOtherCostsComponent,
		contractIfrs.RentDeductionsComponent,

		map.MainMap,

		editablePopover.CountryOwnRegionStoreTreeComponent,
		AddEditAddressDialogComponent,
		AddressTypeTemplateDropdownComponent,
		AreaPlannerComponent,
		CityDropDownComponent,
		CorporateBrandDropDownComponent,
		CountryDropDownComponent,
		DeleteDialogComponent,
		DemarcationListTemplateComponent,
		DropDownComponent,
		EditableButton,
		EditableDateComponent,
		ExtendedDropDownComponent,
		GeographicRegionDropDownComponent,
		ImageLoaderComponent,
		ImageModalComponent,
		IndustryTemplateDropdownComponent,
		LoadingContainerComponent,
		OwnRegionDropDownComponent,
		PdfModalComponent,
		PopoverCountryCodeNameDropDownComponent,
		PopoverEditableGenericDropDownComponent,
		PopoverEditableIdNameDropdownComponent,
		PopoverEditableIdNameGenericDropdownComponent,
		PopoverEditableYesNoDropdown,
		SmallSpinnerComponent,
		StoreFormatDropDownComponent,
		SubShellComponent,
		HierarcicalMenuComponent,
		TabStripComponent,
		PortletComponent,
		NumberDisplayComponent,

		pipes.WeekPipe,
		pipes.MonthYearPipe,
		pipes.ArraySortPipe,
		pipes.TagFilterPipe,
		pipes.TagFilterAnyPipe,
		pipes.SafeUrlPipe,
		pipes.FileExtensionFilterPipe,

		files.DocumentComponent,
		files.DrawingComponent,
		files.PhotoComponent,
		files.FileUploaderComponent,
		files.MediaThumbnailComponent,
		files.MediaViewModalComponent,
		files.TagsSelectorComponent,

		audit.CreatedByComponent,
		audit.ModifiedByComponent

	],
	providers: [],

	exports: [
		// Modules
		TreeviewModule,
		BsDropdownModule,
		ButtonsModule,
		CollapseModule,
		CommonModule,
		DataTableModule,
		FormsModule,
		ModalModule,
		PopoverModule,
		TooltipModule,
		AlertModule,
		TypeaheadModule,
		AngularMultiSelectModule,
		ReactiveFormsModule,
		//Directives
		directives.AutoFocusDirective,

		// Components
		editablePopover.PopoverComponent,
		editablePopover.PopoverDropdownComponent,
		editablePopover.PopoverTextComponent,
		editablePopover.PopoverTextAreaComponent,
		editablePopover.PopoverNumberComponent,
		editablePopover.PopoverDateComponent,
		editablePopover.PopoverMonthComponent,
		editablePopover.PopoverCheckboxListComponent,
		editablePopover.PopoverRadioButtonListComponent,
		editablePopover.ClassificationCodeDropdownComponent,
		editablePopover.EditablePopoverCityDropdownComponent,
		editablePopover.OwnRegionDropdownComponent,
		editablePopover.PopoverSupplierSelectorComponent,
		editablePopover.PopoverSupplierDropdownComponent,
		editablePopover.PopoverContactDropdownComponent,
		editablePopover.PopoverMultipleStoreSelectTypeaheadComponent,
		editablePopover.MultipleOwnRegionStoreTreeComponent,
		editablePopover.CountryOwnRegionStoreTreeComponent,
		editablePopover.PopoverTimeComponent,

		contract.ContractAssignmentSublettingComponent,
		contract.ContractBreakClauseComponent,
		contract.ContractDetailComponent,
		contract.ContractDemarcationListComponent,
		contract.ContractEscalationClauseComponent,
		contract.ContractExtensionComponent,
		contract.ContractGeneralContractInfoComponent,
		contract.ContractGeneralInfoComponent,
		contract.ContractRentChargesComponent,
		contract.ContractTermPossessionComponent,
		contract.ContractDocumentComponent,
		contract.ContractSimplifiedComponent,
		contract.ContractRentDeductionComponent,

		contractIfrs.EntryComponent,
		contractIfrs.CalculationRentCostsRentalSupplementsComponent,
		contractIfrs.CostsWithOwnIndex,
		contractIfrs.ResultsFromInputs,
		contractIfrs.IndexCalculationInformationComponent,
		contractIfrs.TaxOtherCostsComponent,
		contractIfrs.RentDeductionsComponent,

		map.MainMap,

		PortletComponent,
		AddEditAddressDialogComponent,
		AddressTypeTemplateDropdownComponent,
		AreaPlannerComponent,
		CityDropDownComponent,
		CorporateBrandDropDownComponent,
		CountryDropDownComponent,
		DeleteDialogComponent,
		DemarcationListTemplateComponent,
		DropDownComponent,
		EditableButton,
		EditableDateComponent,
		ExtendedDropDownComponent,
		ImageLoaderComponent,
		ImageModalComponent,
		IndustryTemplateDropdownComponent,
		GeographicRegionDropDownComponent,
		LoadingContainerComponent,
		OwnRegionDropDownComponent,
		PdfModalComponent,
		PopoverCountryCodeNameDropDownComponent,
		PopoverEditableGenericDropDownComponent,
		PopoverEditableIdNameDropdownComponent,
		PopoverEditableIdNameGenericDropdownComponent,
		PopoverEditableYesNoDropdown,
		SmallSpinnerComponent,
		StoreFormatDropDownComponent,
		SubShellComponent,
		HierarcicalMenuComponent,
		TabStripComponent,
		NumberDisplayComponent,

		pipes.WeekPipe,
		pipes.MonthYearPipe,
		pipes.ArraySortPipe,
		pipes.TagFilterPipe,
		pipes.TagFilterAnyPipe,
		pipes.SafeUrlPipe,
		pipes.FileExtensionFilterPipe,

		files.DocumentComponent,
		files.DrawingComponent,
		files.PhotoComponent,
		files.FileUploaderComponent,
		files.MediaThumbnailComponent,
		files.MediaViewModalComponent,
		files.TagsSelectorComponent,

	
		audit.CreatedByComponent,
		audit.ModifiedByComponent
	]
})
export class SharedModule { }




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/shared.module.ts